//export const Base_API_URL = "https://localhost:44368";
export const Base_API_URL = "https://api.schoolndegree.com";